// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../sidebars/ConfirmationModal.bs.js";

function toMessageString(t) {
  if (t) {
    return "You are about to update priority order for Modification Campaigns. Are you sure you wish to continue?";
  } else {
    return "You are about to update the status of Modification Campaigns. Are you sure you wish to continue?";
  }
}

var ActionType = {
  toMessageString: toMessageString
};

function UpdateModificationConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  var action_type = Props.action_type;
  return React.createElement(ConfirmationModal.make, {
              title: "Update Modification",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Submit",
              cancel_button_title: "No, Cancel",
              children: React.createElement("p", undefined, action_type ? "You are about to update priority order for Modification Campaigns. Are you sure you wish to continue?" : "You are about to update the status of Modification Campaigns. Are you sure you wish to continue?")
            });
}

var make = UpdateModificationConfirmationModal;

export {
  ActionType ,
  make ,
  
}
/* react Not a pure module */
